import React from "react"; 
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import aboutImage from "../assets/about-image.jpg";
import "./LandingPage.css";
import { Link } from "react-router-dom";




const Navigation = () => {
  return (
  <nav className="navbar custom-navbar navbar-expand-lg">

      <div className="container-fluid">
        <Link className="navbar-brand d-flex align-items-center " to="/">
          <img
            src={aboutImage}
            alt="LEPIC visual"
            className="about-imagee me-2 "
            style={{ width: "40px", height: "40px" }}
          />
          LePic
        </Link>
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item mx-2">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item mx-2">
              <a
                className="nav-link"
                href="https://www.youtube.com/@learnerspick_01"
                target="_blank"
                rel="noopener noreferrer"
              >
                Explore
              </a>
            </li>
            <li className="nav-item mx-2">
              <Link className="nav-link" to="/notes">Notes📓</Link>
            </li>
            <li className="nav-item mx-2">
              <a className="nav-link" href="#Contact">Contact Us</a>
            </li>
            <li className="nav-item mx-2">
              <a
                className="nav-link"
                href="https://docs.google.com/forms/d/e/1FAIpQLSee2BvTH2c0EeD-wT4cqwZCQumoBWU-g1m59fd-mwagt_W14A/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
              >
                Buy Us a Coffee😋
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
